module.exports = __webpack_public_path__ + "143146fa24554ae2c5ac0a3982abb952.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/_iview@3.5.4@iview/dist/styles/fonts/ionicons.woff2?v=3.0.0
// module id = 820
// module chunks = 9